import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

// The design handoff's switch, 32x18: on, filled with the primary text colour and a 14px knob at the right; off, a 1px
// control border and a 12px knob at the left.
const Switch = React.forwardRef(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      "peer inline-flex h-[18px] w-8 shrink-0 cursor-pointer items-center rounded-full border transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring disabled:cursor-not-allowed disabled:opacity-40 data-[state=checked]:border-foreground data-[state=checked]:bg-foreground data-[state=unchecked]:border-gr-control-border data-[state=unchecked]:bg-transparent",
      className
    )}
    {...props}
    ref={ref}>
    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none block rounded-full transition-transform data-[state=checked]:h-3.5 data-[state=checked]:w-3.5 data-[state=checked]:translate-x-[15px] data-[state=checked]:bg-background data-[state=unchecked]:h-3 data-[state=unchecked]:w-3 data-[state=unchecked]:translate-x-px data-[state=unchecked]:bg-gr-control-border"
      )} />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
